module.exports = __webpack_public_path__ + "img/crypto_news.png";